<template>
	<div class="container">
    <div v-if="this.language == 'de'">
        <p>
          schuett-biotec GmbH stellt Geräte für die Biotechnologie, die Mikrobiologie und die Molekularbiologie her. <br>
          Die Geräte werden im eigenen Hause entwickelt, produziert und über ein Händlernetz bundesweit und weltweit vertrieben. <br>
          Aufgrund der vorhandenen Entwicklungskapazitäten und der maschinellen Ausrüstung hat das Unternehmen als Gerätehersteller an Verbundprojekten teilgenommen <br>
          und sucht aktiv auch zukünftig derartige Kooperationen.
          <br>
            <img src="https://backend.schuett-biotec.de/public/gebaeude.gif" class=center>
          <br>
          Ihre Produktideen oder Ihre Wünsche nach Sondergeräten sind bei uns willkommen! <br>
          Sie haben die Idee und gemeinsam erarbeiten wir gerätetechnische Lösungen, die Ihnen einen Vorsprung in Ihren wissenschaftlichen Arbeiten sichern.
          <br>
                   
          </p>
              </div>
    <div v-if="this.language == 'en'">
      <p>
          schuett-biotec GmbH is manufacturing equipment for biotechnology, microbiology and molecular biology. <br>
          The equipment is developed and manufactured in-house, and is then shipped to a network of national and international distributors. <br>
          schuett-biotec has successfully participated in cooperative ventures and projects, due to the existing design and development capacities and their machinery in the past. 
          We are actively looking for further opportunities of that nature. 
          <br>
            <img src="https://backend.schuett-biotec.de/public/gebaeude.gif" class=center>
          <br>
          Your product ideas and wishes for special, unique variations of our products are always welcome. <br>
          <br>
          You have the idea and we work together on the implementation and execution of your customised design, that creates a head-start for your scientific endeavours. 
          <br>
      </p>
    </div>
	</div>
</template>
<script>
export default {
    name: 'portrait',
    data () {
      return {}
    }
};
</script>
<style scoped>
	.container {
    color: black;
    margin: 1rem;
  }
  .center {
      display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    white-space: pre-line;
  }
  table {
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/portrait.vue